import './styles/graphic.scss';
import { json } from 'd3-fetch';
import { select } from 'd3-selection';
import { timeParse, timeFormat, timeFormatDefaultLocale } from 'd3-time-format';

timeFormatDefaultLocale({
  periods: ['a.m.', 'p.m.'],
  days: [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ],
  shortDays: ['Sun', 'Mon', 'Tues', 'Wed', 'Thurs', 'Fri', 'Sat'],
  months: [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ],
  shortMonths: [
    'Jan.',
    'Feb.',
    'March',
    'April',
    'May',
    'June',
    'July',
    'Aug.',
    'Sept.',
    'Oct.',
    'Nov.',
    'Dec.',
  ],
});

export default function (props, container, isMobile) {
  const {
    initialWidth,
    initialHeight,
    gridWidth,
    gridHeight,
    margins,
    data,
    colorScale,
    textColorScale,
    width,
    height,
  } = props;

  let stateCDCdata;
  let datestamp;

  const getCategory = (activityLevel) => {
    if (activityLevel <= 3) { return 'Minimal'; }
    if (activityLevel <= 5) { return 'Low'; }
    if (activityLevel <= 7) { return 'Moderate'; }
    if (activityLevel <= 10) { return 'High'; }
    if (activityLevel <= 13) { return 'Very high'; }
    return 'Not available';
  };

  const drawGrid = function () {
    const shapesEl = document.getElementById('shapes');
    const labelsEl = document.getElementById('labels');
    const squaresEl = document.getElementById('squares');
    const mobileShapesEl = document.getElementById('mobile-shapes');
    const mobileLabelsEl = document.getElementById('mobile-labels');
    const mobileSquaresEl = document.getElementById('mobile-squares');

    // Add the state abbrev. as a class to the labels
    const labels = labelsEl.querySelectorAll('text');
    const mobileLabels = mobileLabelsEl.querySelectorAll('text');
    [...labels, ...mobileLabels].forEach((label) => {
      const className = `label-${label.textContent}`;
      if (!label.classList.contains(className)) {
        label.classList.add(className);
      }
    });

    console.log(squaresEl);
    console.log(mobileSquaresEl);

    // Add the state abbrev. as a class to the shapes
    const shapes = shapesEl.querySelectorAll('path, polygon');
    const mobileShapes = mobileShapesEl.querySelectorAll('path, polygon');
    [...shapes, ...mobileShapes].forEach((shape) => {
      const className = `shape-${shape.id}`;
      if (!shape.classList.contains(className)) {
        shape.classList.add(className);
      }
    });

    const squares = squaresEl.querySelectorAll('rect');
    const mobileSquares = mobileSquaresEl.querySelectorAll('rect');
    [...squares, ...mobileSquares].forEach((sq) => {
      const className = `square-${sq.dataset.name}`;
      if (!sq.classList.contains(className)) {
        sq.classList.add(className);
      }
    });

    const specialLabels = [
      'MA',
      'RI',
      'CT',
      'NJ',
      'DE',
      'DC',
      'MD',
      'HI',
    ];

    const specialLabelsMobile = [
      'NH',
      'VT',
      'RI',
      'CT',
      'NJ',
      'DE',
      'MD',
      'DC',
      'HI',
      'MA',
    ];

    // Change colors
    data.forEach((d) => {
      const path = shapesEl.querySelector(`.shape-${d.key}`);
      const mobilePath = mobileShapesEl.querySelector(`.shape-${d.key}`);
      const square = squaresEl.querySelector(`.square-${d.key}`);
      const mobileSquare = mobileSquaresEl.querySelector(`.square-${d.key}`);

      path.style.setProperty('fill', colorScale(d.category));
      mobilePath.style.setProperty('fill', colorScale(d.category));

      if (square) {
        square.style.setProperty('fill', colorScale(d.category));
      }

      if (mobileSquare) {
        mobileSquare.style.setProperty('fill', colorScale(d.category));
      }

      const label = labelsEl.querySelector(`.label-${d.key}`);
      if (specialLabels.indexOf(d.key) > -1) {
        label.style.setProperty('fill', 'black');
        label.style.setProperty('stroke-width', '3px');
        label.style.setProperty('paint-order', 'stroke');
        label.style.setProperty('stroke', 'rgba(255,255,255,0.8)');
      } else {
        label.style.setProperty('fill', textColorScale(d.category));
        label.style.setProperty('stroke-width', '0');
      }

      const mobileLabel = mobileLabelsEl.querySelector(`.label-${d.key}`);
      if (specialLabelsMobile.indexOf(d.key) > -1) {
        mobileLabel.style.setProperty('fill', 'black');
        mobileLabel.style.setProperty('stroke-width', '3px');
        mobileLabel.style.setProperty('paint-order', 'stroke');
        mobileLabel.style.setProperty('stroke', 'rgba(255,255,255,0.8)');
      } else {
        mobileLabel.style.setProperty('fill', textColorScale(d.category));
        mobileLabel.style.setProperty('stroke-width', '0');
      }
    });


    // Add key
    const keyContainer = select('#key-container');
    keyContainer.html('');
    keyContainer.append('ul')
      .attr('class', 'key')
      .selectAll('li')
      .data(colorScale.domain())
      .enter()
      .append('li')
      .attr('class', 'key-item')
      .html(d => `<span class='key-block' style='background-color:${colorScale(d)};'></span>${d}`);

    // Add timestamp
    select('.timestamp')
      .html('')
      .text((data) => {
        const dataAsOf = timeParse('%Y-%m-%d')(datestamp);
        return `Flu-like illness activity for week ending ${timeFormat('%b %-d, %Y')(dataAsOf)}`;
      });

    window.pymChild.sendHeight();
  };

  // If the data hasn't been loaded -- load it
  if (data[0].category === undefined) {
    json('https://ix.cnn.io/data/flu/v2/latest_by_date.json').then((d) => {
      stateCDCdata = d.data[d.latestWeekId];
      datestamp = d.latestWeekEndDate;
      data.forEach((state) => {
        state.category = getCategory(99);
        const stateData = stateCDCdata.find(s => s.abbr === state.key);
        // console.log(stateData);
        if (stateData) {
          state.category = getCategory(+stateData.activityLevel);
        }
      });

      // if (d.lastUpdatedStr) {
      //   const footnoteEl = document.getElementById('footnote');
      //   if (footnoteEl) {
      //     footnoteEl.textContent = `Note: Data current as of ${d.lastUpdatedStr}.`;
      //   }
      // }

      drawGrid();
    });
  } else {
    drawGrid();
  }
}
